import { TechStack } from '../Components/Skills/TechStack';
import { MainLayout } from '../styles/Layouts';
import { ProSkills } from '../Components/Skills/ProSkills';
import { Qualities } from '../Components/Skills/Qualities';

export const Skills = () => {
  return (
    <MainLayout>
      <TechStack />
      <ProSkills />
      <Qualities />
    </MainLayout>
  );
};
